<template>
  <main class="l-main">
    <div class="l-error c-card">
      <div class="l-error__inner-red">
        <div class="l-error__message l-error__message--red">
          <span
            ><Icon name="alert" color="#CC0621" width="31" height="28"
          /></span>
          <slot></slot>
        </div>
        <div class="l-error__btn">
          <div class="c-buttonWrap4">
            <ButtonLink
              tag="a"
              :href="domainTop"
              style-type="primary"
              color="color2"
            >
              トップページへ
            </ButtonLink>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'ErrorLayout',
  computed: {
    domainTop() {
      return process.env.VUE_APP_TOP_DOMAIN;
    }
  },
  mounted() {
    this.$meta.setDocumentTitle("エラーが発生しました。");
    this.$page.isBreadcrumb = false;
    this.$page.isPageHeader = false;
    this.$page.isPageTop = false;
    this.$page.isSubHeader = true;
    this.$page.showFooterMenu = false;
    this.$page.isFooterText = false;
  },
  watch: {
    $route() {
      this.$meta.setDocumentTitle("エラーが発生しました。");
      this.$page.isBreadcrumb = false;
      this.$page.isPageHeader = false;
      this.$page.isPageTop = false;
      this.$page.isSubHeader = true;
      this.$page.showFooterMenu = false;
      this.$page.isFooterText = false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./../l-error.scss";
@import "./../l-main.scss";
  .l-error__message--red p {
    color: #000;
  }
  .l-error__message--red a {
    word-break: break-all;
  }
</style>
